<template>
  <li :id="`message-${reply.id}`" class="message">
    <thread-reply v-if="!reply.isDeleted" v-bind="reply" :thread-id="threadId" />
    <message-unavailable v-else :id="reply.id" :unavailable-reason="unavailableReason" class="reply restore-comment" :thread-id="threadId"
                         :restore-button-title="restoreButtonTitle" @restore="restoreReply" />
  </li>
</template>

<script>
import MessageUnavailable from './message-unavailable'
import ThreadReply from './thread-reply'
import { mapActions } from 'vuex'

export default {
  components: { MessageUnavailable, ThreadReply },
  props: {
    reply: {
      type: Object,
      required: true
    },
    threadId: {
      type: Number,
      required: true
    }
  },
  computed: {
    restoreButtonTitle() {
      return this.i18n.t('member.forums.restore_message', {content: this.reply.plainTextBeginning})
    },

    unavailableReason() {
      // If the message id is missing, the record was physically deleted
      return this.reply.id === null ? 'physically_deleted' : 'logically_deleted'
    }
  },
  methods: mapActions(['restoreReply'])
}
</script>

<style scoped lang="scss">
  .message {
    background-color: #F3F3F3;
    margin-bottom: 10px;
  }

  .reply {
    display: flex;
  }
</style>
